function isCSVFile(file) {
  const type = file.fileType;
  const name = file.filename?.toLowerCase() || "";

  const validMimeTypes = [
    "text/csv",
    "application/vnd.ms-excel"
  ];

  return validMimeTypes.includes(type) && name.endsWith(".csv");
};

export { isCSVFile };